import {
  GET_BUILDER_LOGO,
  GET_BUILDER_PROJECT_GALLERY,
  REMOVE_IMAGE_FROM_BUILDER_PROJECT_GALLERY,
  RESET_BUILDER_PROJECT_GALLERY,
} from './actionTypes';

export const getBuilderLogo = image => ({
  type: GET_BUILDER_LOGO,
  payload: image,
});

export const setBuilderProjectGalleryImages = image => ({
  type: GET_BUILDER_PROJECT_GALLERY,
  payload: image,
});

export const removeImageBuilderProjectGalleryImages = index => ({
  type: REMOVE_IMAGE_FROM_BUILDER_PROJECT_GALLERY,
  payload: index,
});

export const resetBuilderProjectGalleryImages = () => ({
  type: RESET_BUILDER_PROJECT_GALLERY,
});
